import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { User } from 'Types';
import { useGetViewer } from 'Api/Queries';

type Props = {
  children: React.ReactElement;
};

export type AuthContextType = {
  user: User | null;
};

const AuthContext = React.createContext<AuthContextType>({
  user: null,
});

const AuthProvider = ({ children }: Props): React.ReactElement => {
  const [user, setUser] = useState<User | null>(null);
  const { i18n } = useTranslation();

  useGetViewer({
    onCompleted: ({ viewer }) => {
      setUser(viewer);
      i18n.changeLanguage(viewer.lang);
    },
  });

  return (
    <AuthContext.Provider value={{ user }}>{children}</AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };
